import { render, staticRenderFns } from "./PayRangesListPage.vue?vue&type=template&id=e28ad6dc&scoped=true"
import script from "./PayRangesListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangesListPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangesListPage.vue?vue&type=style&index=0&id=e28ad6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28ad6dc",
  null
  
)

export default component.exports